<template>
    <div class="__emails-container"> 

      <div class="__navigators">
            <nav class="breadcrumb3">
              <ol>
                  <li><a v-bind:href="h.routes.home" v-text="t.label_home" data-ba-i="breadcrumb-home"></a></li>
                  <li><a v-bind:href="h.routes.init" v-text="t.title_emails_app" data-ba-i="breadcrumb-custom-emails"></a></li>
                  <li><a v-bind:href="h.routes.list_emails" v-text="t.emails_list"  data-ba-i="breadcrumb-emails-list"></a></li>
                  <li><a v-bind:href="h.routes.settings" v-text="t.configurations"  data-ba-i="breadcrumb-emails-settings"></a></li>
              </ol>
          </nav>
      </div>

      <div class="__wrapper">

        <div class="__tabs">
          <a 
            v-text="t.mailapp_config_forward"
            @click="activeComponent = 'forward'"
            :class="[{__active : activeComponent == 'forward'}]"
            data-ba-i="forward-list">
            Forward
          </a>
          <a 
            v-text="t.mailapp_config_alias"
            @click="activeComponent = 'alias'"
            :class="[{__active : activeComponent == 'alias'}]"
            data-ba-i="alias-list">
          </a>
        </div>

        <!-- <component :is="activeComponent"></component> It does not work. is incompatible with bootstrap modal -->

        <emails-settings-forward
          v-show="activeComponent == 'forward'"
          class="__content" 
          key="forward">
        </emails-settings-forward>

        <emails-settings-alias
          v-show="activeComponent == 'alias'"
          class="__content" 
          key="alias">
        </emails-settings-alias>

      </div>
    </div>
      
</template>

<script type="text/javascript">

  import qs from "qs";
  import punycode from "punycode";

  export default {

    name: "emails-settings",
    props: ["app"],
    data() {
        return {
        	h:                this.app.handlers,
        	t:                this.app.translations,
          email:              this.app.email,
          activeComponent:    'forward'
        };
    },

    methods: {
      toUnicode(text, isEmail){
          if(isEmail){
            if(text.includes('@')){
              let parts = text.split('@')
              return punycode.toUnicode(parts[0]) + '@' + punycode.toUnicode(parts[1]) 
            }
          }
          
          return punycode.toUnicode(text)
      },
      toASCII(text, isEmail){
         if(isEmail){
            if(text.includes('@')){
              let parts = text.split('@')
              let ret = punycode.toASCII(parts[0]) + '@' + punycode.toASCII(parts[1])
              return ret
            }
          }
          
          return punycode.toASCII(text)
      },
      validateEmail(email) {
        email = this.toASCII(email, true)
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }
    },
};
</script>

<style lang="scss">
@import '../../../scss/emails-app/default.scss';
</style>


// WEBPACK FOOTER //
// resources/office/js/components/emails-app/emails-settings.vue